export enum LocalStorageKey {
    DefaultViewId = 'DefaultViewId',
    ExpiresAt = 'ExpiresAt',
    ExpiresAtSet = 'ExpiresAtSet',
    GlobalNavigationIsCollapsed = 'GlobalNavigationIsCollapsed',
    ThemeSetting = 'ThemeSetting',
    DocumentChecklist = 'DocumentChecklist',
}
